var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstachampLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 25,
    viewBox: "0 0 148 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.238 18.866c-.35 0-.643-.12-.881-.358A1.2 1.2 0 010 17.625V1.48c0-.366.119-.66.357-.883C.595.358.888.24 1.237.24c.365 0 .659.119.881.357.238.223.357.517.357.883v16.146a1.2 1.2 0 01-.357.883c-.222.238-.516.358-.88.358z",
    fill: "url(#instachamp-logo_svg__paint0_linear_424_31240)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.985 18.89a1.24 1.24 0 01-.88-.335 1.246 1.246 0 01-.334-.882v-5.867c0-.906-.166-1.646-.5-2.218a3.062 3.062 0 00-1.356-1.264c-.555-.286-1.198-.43-1.928-.43a3.98 3.98 0 00-1.808.406c-.54.27-.968.636-1.285 1.097-.318.445-.476.962-.476 1.55h-1.5c0-1.001.238-1.892.714-2.671a5.305 5.305 0 012-1.884c.84-.461 1.784-.692 2.831-.692 1.095 0 2.07.239 2.928.716.872.46 1.555 1.144 2.046 2.05.508.907.762 2.02.762 3.34v5.867a1.2 1.2 0 01-.357.882c-.222.223-.508.334-.857.334zm-9.781 0a1.24 1.24 0 01-.88-.335 1.246 1.246 0 01-.334-.882V7.036c0-.366.111-.66.333-.883a1.24 1.24 0 01.88-.334c.366 0 .66.112.881.334.222.223.334.517.334.883v10.637c0 .35-.112.644-.334.882-.222.223-.515.334-.88.334z",
    fill: "url(#instachamp-logo_svg__paint1_linear_424_31240)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.948 18.96c-1.11 0-2.142-.166-3.093-.5-.936-.35-1.666-.787-2.19-1.312-.238-.254-.341-.54-.31-.858a1.2 1.2 0 01.477-.811c.317-.255.626-.358.928-.31.317.031.587.167.809.405.27.302.698.589 1.285.859.603.254 1.27.381 2 .381.92 0 1.618-.15 2.094-.453.491-.302.745-.691.761-1.168.016-.477-.214-.89-.69-1.24-.46-.35-1.309-.637-2.546-.86-1.603-.317-2.77-.794-3.499-1.43-.714-.636-1.07-1.415-1.07-2.338 0-.81.237-1.478.713-2.003.476-.54 1.087-.938 1.833-1.193a6.791 6.791 0 012.332-.405c1.047 0 1.975.167 2.784.5.81.335 1.452.796 1.928 1.384.222.255.325.525.31.811-.016.27-.151.501-.405.692-.254.175-.555.23-.905.167a1.704 1.704 0 01-.88-.43c-.397-.381-.825-.644-1.285-.787-.46-.143-.992-.214-1.595-.214-.698 0-1.293.119-1.785.357-.476.239-.714.589-.714 1.05 0 .286.072.548.215.787.158.223.46.43.904.62.444.175 1.095.35 1.951.525 1.19.238 2.127.54 2.809.906.698.366 1.198.795 1.5 1.288.3.477.451 1.034.451 1.67 0 .73-.198 1.39-.595 1.979-.38.588-.952 1.057-1.713 1.407-.746.35-1.682.525-2.809.525z",
    fill: "url(#instachamp-logo_svg__paint2_linear_424_31240)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.87 18.866a3.951 3.951 0 01-2.141-.597 4.356 4.356 0 01-1.5-1.67c-.365-.699-.547-1.486-.547-2.36V2.862c0-.35.111-.636.333-.859.222-.222.508-.333.857-.333s.635.11.857.333c.222.223.333.51.333.859v11.377c0 .636.174 1.168.523 1.597.35.43.778.644 1.286.644h.809c.285 0 .523.112.714.334.206.223.31.51.31.859 0 .35-.136.636-.406.859-.253.222-.587.334-.999.334h-.428zM35.588 8.348c-.333 0-.603-.096-.809-.287a.934.934 0 01-.31-.715c0-.318.104-.573.31-.763.206-.191.476-.287.81-.287h5.497c.333 0 .603.096.809.287.206.19.31.445.31.763a.934.934 0 01-.31.715c-.206.191-.476.287-.81.287h-5.497z",
    fill: "url(#instachamp-logo_svg__paint3_linear_424_31240)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.113 18.96c-1.158 0-2.197-.285-3.118-.858a6.393 6.393 0 01-2.19-2.36c-.523-1.003-.785-2.132-.785-3.388 0-1.256.286-2.385.857-3.386a6.46 6.46 0 012.356-2.362c1-.588 2.118-.882 3.356-.882s2.348.294 3.332.882a6.28 6.28 0 012.332 2.362c.587 1.001.88 2.13.88 3.386h-.928c0 1.257-.27 2.385-.809 3.387a6.205 6.205 0 01-2.165 2.361c-.92.573-1.96.859-3.118.859zm.476-2.146c.81 0 1.531-.19 2.166-.572a4.266 4.266 0 001.499-1.598c.365-.684.547-1.447.547-2.29 0-.858-.182-1.621-.547-2.29a4.043 4.043 0 00-1.5-1.597c-.634-.398-1.356-.596-2.165-.596-.793 0-1.515.198-2.166.596a4.214 4.214 0 00-1.523 1.598c-.365.668-.547 1.43-.547 2.29 0 .842.182 1.605.547 2.289.38.668.889 1.2 1.523 1.598.65.382 1.373.572 2.166.572zm5.33 2.075a1.24 1.24 0 01-.88-.334 1.246 1.246 0 01-.333-.882v-3.65l.452-2.527 1.976.858v5.319a1.2 1.2 0 01-.357.882c-.223.223-.508.334-.857.334z",
    fill: "url(#instachamp-logo_svg__paint4_linear_424_31240)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.314 19.104a9.18 9.18 0 01-3.617-.715 9.39 9.39 0 01-2.928-2.028 9.843 9.843 0 01-1.951-3.053c-.46-1.16-.69-2.416-.69-3.768 0-1.336.23-2.576.69-3.72a9.55 9.55 0 011.951-3.03A9.2 9.2 0 0166.697.74C67.807.245 69.013 0 70.314 0c1.222 0 2.269.159 3.142.477.888.318 1.777.843 2.665 1.574.127.096.222.199.286.31.079.096.127.199.142.31.032.096.048.215.048.358 0 .302-.111.556-.333.763-.206.191-.46.302-.762.334-.301.016-.595-.087-.88-.31a6.98 6.98 0 00-1.833-1.169c-.619-.27-1.444-.405-2.475-.405-.936 0-1.816.19-2.642.572a7.122 7.122 0 00-2.19 1.574 7.344 7.344 0 00-1.45 2.338 7.52 7.52 0 00-.524 2.814 7.77 7.77 0 00.523 2.862 7.412 7.412 0 001.452 2.314 7.122 7.122 0 002.19 1.574 6.446 6.446 0 002.641.548c.81 0 1.57-.135 2.285-.405a9.104 9.104 0 002.094-1.169c.286-.207.563-.294.833-.262.286.016.524.127.714.334.19.19.286.46.286.81 0 .16-.032.319-.096.478a1.354 1.354 0 01-.285.405 9.524 9.524 0 01-2.76 1.55 8.962 8.962 0 01-3.07.525z",
    fill: "url(#instachamp-logo_svg__paint5_linear_424_31240)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.46 14.12a1.24 1.24 0 01-.88-.335 1.246 1.246 0 01-.334-.882V1.455c0-.366.112-.66.334-.883a1.24 1.24 0 01.88-.333c.365 0 .659.11.88.333.223.223.334.517.334.883v11.448c0 .35-.111.644-.333.882-.222.223-.516.334-.88.334zm9.782 4.77a1.24 1.24 0 01-.88-.335 1.246 1.246 0 01-.334-.882v-5.867c0-.906-.167-1.646-.5-2.218a3.061 3.061 0 00-1.356-1.264c-.556-.286-1.198-.43-1.928-.43-.666 0-1.27.136-1.809.406-.54.27-.968.636-1.285 1.097-.317.445-.476.962-.476 1.55h-1.5c0-1.001.239-1.892.715-2.671a5.305 5.305 0 011.999-1.884c.84-.461 1.785-.692 2.832-.692 1.095 0 2.07.239 2.927.716.873.46 1.555 1.144 2.047 2.05.508.907.761 2.02.761 3.34v5.867a1.2 1.2 0 01-.357.882c-.222.223-.507.334-.856.334zm-9.782 0a1.24 1.24 0 01-.88-.335 1.246 1.246 0 01-.334-.882V7.036c0-.366.112-.66.334-.883a1.24 1.24 0 01.88-.334c.365 0 .659.112.88.334.223.223.334.517.334.883v10.637c0 .35-.111.644-.333.882-.222.223-.516.334-.88.334z",
    fill: "url(#instachamp-logo_svg__paint6_linear_424_31240)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.918 18.96c-1.158 0-2.197-.285-3.117-.858a6.393 6.393 0 01-2.19-2.36c-.523-1.003-.785-2.132-.785-3.388 0-1.256.285-2.385.857-3.386a6.46 6.46 0 012.356-2.362c.999-.588 2.118-.882 3.355-.882 1.238 0 2.348.294 3.332.882a6.276 6.276 0 012.332 2.362c.588 1.001.881 2.13.881 3.386h-.928c0 1.257-.27 2.385-.809 3.387a6.21 6.21 0 01-2.166 2.361c-.92.573-1.959.859-3.118.859zm.476-2.146c.809 0 1.531-.19 2.166-.572a4.262 4.262 0 001.499-1.598c.365-.684.548-1.447.548-2.29 0-.858-.183-1.621-.548-2.29a4.04 4.04 0 00-1.499-1.597c-.635-.398-1.357-.596-2.166-.596a4.07 4.07 0 00-2.165.596 4.212 4.212 0 00-1.523 1.598c-.365.668-.548 1.43-.548 2.29 0 .842.183 1.605.547 2.289.381.668.889 1.2 1.524 1.598.65.382 1.372.572 2.165.572zm5.331 2.075a1.24 1.24 0 01-.88-.334 1.246 1.246 0 01-.333-.882v-3.65l.452-2.527 1.975.858v5.319a1.2 1.2 0 01-.357.882c-.222.223-.508.334-.857.334z",
    fill: "url(#instachamp-logo_svg__paint7_linear_424_31240)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M129.64 18.89c-.349 0-.643-.112-.881-.335a1.246 1.246 0 01-.333-.882v-6.821c0-1.002-.246-1.741-.738-2.218-.492-.493-1.134-.74-1.928-.74-.825 0-1.507.287-2.046.859-.524.572-.786 1.304-.786 2.194h-1.975c0-1.033.222-1.94.666-2.719a4.754 4.754 0 011.857-1.86c.809-.445 1.729-.668 2.76-.668.905 0 1.706.199 2.404.596.698.398 1.238.986 1.618 1.765.397.764.595 1.694.595 2.79v6.822c0 .35-.111.644-.333.882-.222.223-.515.334-.88.334zm-15.874 0c-.349 0-.643-.112-.881-.335a1.246 1.246 0 01-.333-.882V7.06c0-.366.111-.66.333-.883.238-.222.532-.334.881-.334.365 0 .658.112.88.334.222.223.333.517.333.883v10.613c0 .35-.111.644-.333.882-.222.223-.515.334-.88.334zm7.948 0a1.24 1.24 0 01-.88-.335 1.246 1.246 0 01-.333-.882v-6.821c0-1.002-.246-1.741-.738-2.218-.492-.493-1.134-.74-1.928-.74-.825 0-1.507.287-2.046.859-.54.572-.81 1.304-.81 2.194h-1.499c0-1.033.206-1.94.619-2.719a4.615 4.615 0 011.713-1.86c.73-.445 1.563-.668 2.499-.668.905 0 1.706.199 2.404.596.698.398 1.237.986 1.618 1.765.397.764.595 1.694.595 2.79v6.822c0 .35-.111.644-.333.882-.222.223-.516.334-.881.334z",
    fill: "url(#instachamp-logo_svg__paint8_linear_424_31240)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M136.1 24.446c-.349 0-.642-.119-.88-.357-.222-.223-.333-.51-.333-.859V12.354c.016-1.256.309-2.385.88-3.386a6.279 6.279 0 012.333-2.362c.983-.588 2.094-.882 3.331-.882 1.254 0 2.372.294 3.356.882a6.276 6.276 0 012.332 2.362c.587 1.001.881 2.13.881 3.386 0 1.257-.27 2.385-.809 3.387a6.21 6.21 0 01-2.166 2.361c-.92.573-1.959.859-3.118.859-.936 0-1.8-.19-2.594-.572a6.319 6.319 0 01-1.999-1.598v6.44c0 .349-.111.635-.333.858-.222.238-.516.357-.881.357zm5.331-7.632c.81 0 1.532-.19 2.166-.572a4.265 4.265 0 001.5-1.598c.38-.684.571-1.447.571-2.29 0-.858-.191-1.621-.571-2.29a4.042 4.042 0 00-1.5-1.597c-.634-.398-1.356-.596-2.166-.596a4.07 4.07 0 00-2.165.596 4.042 4.042 0 00-1.5 1.598c-.365.668-.547 1.43-.547 2.29 0 .842.182 1.605.547 2.289.365.668.865 1.2 1.5 1.598.65.382 1.372.572 2.165.572z",
    fill: "url(#instachamp-logo_svg__paint9_linear_424_31240)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "instachamp-logo_svg__paint0_linear_424_31240",
    x1: -2.38,
    y1: 10.915,
    x2: 140.904,
    y2: 10.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#815CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#FB836F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6B73E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "instachamp-logo_svg__paint1_linear_424_31240",
    x1: -2.38,
    y1: 10.915,
    x2: 140.904,
    y2: 10.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#815CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#FB836F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6B73E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "instachamp-logo_svg__paint2_linear_424_31240",
    x1: -2.38,
    y1: 10.915,
    x2: 140.904,
    y2: 10.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#815CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#FB836F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6B73E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "instachamp-logo_svg__paint3_linear_424_31240",
    x1: -2.38,
    y1: 10.915,
    x2: 140.904,
    y2: 10.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#815CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#FB836F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6B73E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "instachamp-logo_svg__paint4_linear_424_31240",
    x1: -2.38,
    y1: 10.915,
    x2: 140.904,
    y2: 10.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#815CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#FB836F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6B73E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "instachamp-logo_svg__paint5_linear_424_31240",
    x1: -2.38,
    y1: 10.915,
    x2: 140.904,
    y2: 10.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#815CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#FB836F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6B73E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "instachamp-logo_svg__paint6_linear_424_31240",
    x1: -2.38,
    y1: 10.915,
    x2: 140.904,
    y2: 10.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#815CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#FB836F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6B73E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "instachamp-logo_svg__paint7_linear_424_31240",
    x1: -2.38,
    y1: 10.915,
    x2: 140.904,
    y2: 10.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#815CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#FB836F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6B73E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "instachamp-logo_svg__paint8_linear_424_31240",
    x1: -2.38,
    y1: 10.915,
    x2: 140.904,
    y2: 10.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#815CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#FB836F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6B73E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "instachamp-logo_svg__paint9_linear_424_31240",
    x1: -2.38,
    y1: 10.915,
    x2: 140.904,
    y2: 10.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#815CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#FB836F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6B73E"
  })))));
}

export default __webpack_public_path__ + "./fonts/instachamp-logo.886d34a0e458d29e31e61872800400c6.svg";
export { SvgInstachampLogo as ReactComponent };